import * as Conditions from "./external_script/forms/fields/conditions";
import * as DatePicker from "./external_script/forms/fields/datepicker";
import * as FormHelpers from "./external_script/forms/helpers";
import * as Locations from "./external_script/forms/fields/locations";
import * as MultiSelect from "./external_script/forms/fields/multiselect";
import { MultiStepForm } from "./multi_step_form";

export function init(form_container) {
  initDisclaimerModal(form_container);
  initImageUploadFileInput(form_container);
  initFormPhoneNumberValidation(form_container);
  MultiSelect.init(form_container);
  DatePicker.init(form_container);
  Conditions.init(form_container);
  FormHelpers.loadUrlParamIntoHiddenFields(form_container);
  Locations.init(form_container);
  MultiStepForm.init();
}

export function initDisclaimerModal(form_container) {
  const modal_trigger = form_container.querySelector(
    ".driftrock [data-disclaimer-modal-trigger]",
  );
  const modal_close = form_container.querySelector(
    ".driftrock [data-disclaimer-modal-close]",
  );
  const modal = form_container.querySelector(
    ".driftrock [data-disclaimer-modal]",
  );

  if (modal_trigger && modal) {
    modal_trigger.addEventListener("click", (event) => {
      modal.classList.add("is-active");
    });

    modal_close.addEventListener("click", (event) => {
      modal.classList.remove("is-active");
    });

    const div = document.createElement("div");
    div.classList.add("driftrock");
    div.style.position = "fixed";
    div.style.zIndex = 99999;
    div.appendChild(modal);
    document.body.appendChild(div);
  }
}

function initImageUploadFileInput(form_container) {
  const submit_button = form_container.querySelector(
    ".driftrock [data-form-submit]",
  );
  const image_label = form_container.querySelector(
    ".driftrock [data-image-label]",
  );
  const image_label_warning = form_container.querySelector(
    ".driftrock [data-image-label-warning]",
  );
  const file_input = form_container.querySelector(
    ".driftrock [data-image-upload]",
  );
  const file_input_value = form_container.querySelector(
    ".driftrock [data-image-upload-value]",
  );

  if (file_input) {
    const form_id = file_input.dataset.formId;

    file_input.addEventListener("invalid", function (e) {
      image_label_warning.classList.toggle("d-none");
    });

    file_input.addEventListener("input", (event) => {
      submit_button.disabled = true;

      image_label.classList.remove("d-none");
      const file = file_input.files[0];
      var imagePreview = image_label.querySelector("img");

      // reuse existing img
      if (!imagePreview) {
        imagePreview = document.createElement("img");
        image_label.appendChild(imagePreview);
      }

      // show preview
      var reader = new FileReader();
      reader.onload = function (e) {
        imagePreview.src = e.target.result;
      };
      reader.readAsDataURL(file);

      var request = fetch(`/uploads/${form_id}/sign?mime-type=${file.type}`, {
        method: "POST",
      });

      request
        .then((response) => response.json())
        .then((response) => {
          uploadToCloudStorage(response.upload_url, file, submit_button);
          file_input_value.value = response.resource;
        })
        .catch((error) => {
          console.log("unknown error");
        });
    });
  }
}

function attemptPhoneNumberValidation(
  phone_number_input,
  country_code_dropdown,
) {
  const country_code = country_code_dropdown.value;
  const phone_number = phone_number_input.value;

  phone_number_input.setCustomValidity("A valid phone number is required");
  phone_number_input.checkValidity();
  phone_number_input.classList.add("form__input--invalid");

  FormHelpers.checkPhoneNumberValidity(country_code, phone_number).then(
    (data) => {
      if (data.valid && data.valid == true) {
        phone_number_input.setCustomValidity("");
        phone_number_input.checkValidity();
        phone_number_input.classList.remove("form__input--invalid");

        const warning_element =
          phone_number_input.parentElement.querySelector(".hf-warning");

        if (warning_element) {
          warning_element.remove();
        }
      }
    },
  );
}

function initFormPhoneNumberValidation(form_container) {
  return;

  const phoneNumberInputs =
    form_container.querySelectorAll("input[type='tel']");
  if (phoneNumberInputs.length > 0) {
    [...phoneNumberInputs].forEach((phone_number_input) => {
      const country_code_dropdown = form_container.querySelector(
        `#${phone_number_input.id}-prefix`,
      );

      country_code_dropdown.addEventListener("change", function (event) {
        attemptPhoneNumberValidation(phone_number_input, country_code_dropdown);
      });

      phone_number_input.addEventListener("change", function (event) {
        attemptPhoneNumberValidation(phone_number_input, country_code_dropdown);
      });
    });
  }
}

function uploadToCloudStorage(signed_url, file, submit_button) {
  fetch(signed_url, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  })
    .then((response) => response.text())
    .then((result) => {
      submit_button.disabled = false;
    })
    .catch((error) => {
      console.error("external error");
    });
}
